import React, { memo, useEffect, useState } from "react";
import Topbar from "../../components/Topbar/Topbar";
import { delete_icon, edit_icon } from "../../assets/img";
import { Table } from "../../components/Table/Table";
import { useNavigate } from "react-router-dom";
import { deletes, get, patch, put } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import { toast } from "react-toastify";
import CreateOutlinedIcon from "@mui/icons-material/CreateOutlined";
import DownloadDoneOutlinedIcon from "@mui/icons-material/DownloadDoneOutlined";

const MMCPlans = () => {
  const navigate = useNavigate();
  const [editGst, setEditGst] = useState(false);
  const [gst, setGst] = useState("18%");
  const [selected, setSelected] = useState(false);
  const [list, setList] = useState([]);

  const handleNavigation = (type, prob) => {
    navigate("/mmc-edit-plan", { state: { type: type, ...(prob ?? {}) } });
  };

  const columns = React.useMemo(() => {
    return [
      {
        Header: "S.No",
        accessor: "",
        Cell: ({ value, row }) => {
          return <p className="red">{row.index + 1}</p>;
        },
      },
      {
        Header: "Plan Name",
        accessor: "name",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "Amount",
        accessor: "amount",
        Cell: ({ value, row }) => {
          return <p className="">₹ {String(value).padStart(2, 0)}</p>;
        },
      },
      {
        Header: "GST%",
        accessor: "gst",
        Cell: ({ value, row }) => {
          return <p className="">{String(value).padStart(2, 0)} %</p>;
        },
      },
      {
        Header: "Plan Validity",
        accessor: "plan_days",
        Cell: ({ value, row }) => {
          return <p className="text-center">{value}</p>;
        },
      },
      {
        Header: "Total Amount",
        accessor: "total_amount",
        Cell: ({ value, row }) => {
          return <p className="">₹ {value}</p>;
        },
      },
      // {
      //   Header: "Status",
      //   accessor: "status",
      //   Cell: ({ value, row }) => {
      //     return (
      //       <div>
      //         <button

      //           className={`${
      //             value === 1 ? "active-btn" : "deactive-btn"
      //           } border-0 ms-2`}
      //           style={{ fontSize: "12px" }}
      //         >
      //           {value === 1 ? " Active" : "De-active"}
      //         </button>
      //       </div>
      //     );
      //   },
      // },
      {
        Header: "Action",
        accessor: "is_default",
        Cell: ({ value, row }) => (
          <div className="d-flex ac-js">
            <button
              onClick={() =>
                handleNavigation("edit", {
                  data: row.original,
                })
              }
              className="cust-btn"
            >
              <img src={edit_icon} alt="" className="mx-2 edit-btn" />
            </button>

            {/* <button
              onClick={() =>
                handleNavigation("view", {
                  data: row.original,
                })
              }
              className="cust-btn"
            >
              <img src={view_icon} alt="" className="mx-2 edit-btn" />
            </button> */}
            {!value && (
              <button
                onClick={() =>
                  setSelected({ type: "delete", data: row.original })
                }
                className="cust-btn "
              >
                <img src={delete_icon} alt="" className="edit-btn" />
              </button>
            )}
          </div>
        ),
      },
    ];
  }, []);

  console.log("selected console", selected);

  //api functions

  const getList = async (page = 1) => {
    let res = await get(`${URLS.MMC_PLANS}`);
    if (res?.status === "success") {
      setList(res?.data);
      setGst(res?.gst_master?.gst + "%");
    }
  };
  useEffect(() => {
    getList();
  }, []);

  const handleDelete = async (data) => {
    if (data?.has_subscription) {
      toast.error(
        "This plan cannot be deleted because it is currently mapped to a property.",
      );
      return;
    }
    let res = await deletes(`${URLS.MMC_PLANS}${data?.id}/`);
    if (res?.status === "success") {
      setList((prev) => prev?.filter((item) => item?.id != data?.id));
      toast.success(res?.message);
      setSelected(false);
    }
  };

  const handleEditGst = async () => {
    let res = await patch(URLS.MMC_GST_EDIT, { gst: gst });
    if (res?.status === "success") {
      setGst(res?.data?.gst + "%");
      toast.success(res?.message);
      setEditGst(false);
    }
  };

  return (
    <div>
      <Topbar header={"MMC Plans"} back={true} />
      <h5>MMC Plans</h5>

      <div className="d-flex ae-jb">
        <div className="gst-master-container">
          <p className="f2 fs-sm-12 fs-md-14 fs-lg-15 fs-xl-16 fs-xxl-18">
            GST Masters
          </p>
          <hr className="mt-2 mb-2" />
          <p className="f1 fs-sm-7 fs-md-9 fs-lg-10 fs-xl-10 fs-xxl-12 red">
            Enter GST percentage to fetch MMC plans.
          </p>
          <div className="gst-input-container d-flex ac-jb">
            <input
              type="text"
              value={gst}
              onChange={(e) => setGst(e.target.value)}
              readOnly={!editGst}
              className="border-0 f3 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16"
            />
            <div
              onClick={() => (editGst ? handleEditGst() : setEditGst(true))}
              className="video-left-line ps-2 pe-2 pointer"
            >
              {editGst ? (
                <DownloadDoneOutlinedIcon
                  htmlColor="#3C3C4399"
                  fontSize="small"
                />
              ) : (
                <CreateOutlinedIcon htmlColor="#3C3C4399" fontSize="small" />
              )}
            </div>
          </div>
        </div>
        <button
          className="f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 white push-btn bg-primar"
          onClick={() =>
            handleNavigation("add", { data: { gst: gst?.replaceAll("%", "") } })
          }
        >
          + Add Plans
        </button>
      </div>

      <Table
        columns={columns}
        data={list ?? []}
        show={true}
        setPageno={() => {}}
      />

      {console.log(
        "selected?.data?.has_subscription",
        selected?.data?.has_subscription,
      )}

      {selected.type === "delete" && (
        <div className="img-popup-design">
          <div className="img-popup">
            {Boolean(selected?.data?.has_subscription) && (
              <p className="text-danger mb-2 mt-2">
                This Plan has Subcribed by Users.It Cannot be deleted.
              </p>
            )}
            <p>Are you sure, want to Delete?</p>
            <div className="d-flex ac-jb px-2 mt-5">
              <button
                onClick={() => handleDelete(selected?.data)}
                className="add-btn w-40"
              >
                Yes
              </button>

              <button
                onClick={() => setSelected(false)}
                className="back-btn f2 w-40"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MMCPlans;
